import { LeafGenerator } from "./src/LeafGenerator";
import {$, T} from "./../../../../../../lmb_factory_theme/assets/src/javascript/src/common/drupal/drupal";

(function (Drupal) {
    'use strict';
    Drupal.behaviors.leafGenerator = {
        attach: function (context, settings) {
            T.contextIsRoot(context) && LeafGenerator.bind();
        }
    };
}(Drupal));
